import React, { useState, ReactNode } from 'react';
import { ClipboardContext, ClipboardItem } from './ClipboardContext';

// Provider props type
interface ClipboardProviderProps {
  children: ReactNode;
}

// Create the provider component
export const ClipboardProvider: React.FC<ClipboardProviderProps> = ({ children }) => {
  const [copiedCharges, setCopiedCharges] = useState<ClipboardItem[]>([]);

  const clearCopiedCharges = () => {
    setCopiedCharges([]);
  };

  const value = {
    copiedCharges,
    setCopiedCharges,
    clearCopiedCharges,
  };

  return <ClipboardContext.Provider value={value}>{children}</ClipboardContext.Provider>;
};
